module.exports = __webpack_public_path__ + "img/mtover.3332b2b9.png";